'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiExportOutline = function TiExportOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37.9 16.3c-0.1 0-6.8-6.8-10-10.2-0.7-0.7-1.7-1.1-2.7-1.1-1.9 0-3.5 1.5-3.5 3.3h-13.4c-0.9 0-1.6 0.8-1.6 1.7v23.3c0 1 0.7 1.7 1.6 1.7h23.4c0.9 0 1.6-0.7 1.6-1.7v-10c2.4-2.5 4.5-4.6 4.6-4.6 0.6-0.7 0.6-1.7 0-2.4z m-12.4 10.3c-0.1 0-0.1 0.1-0.3 0.1-0.1 0-0.2-0.1-0.2-0.1v-6.6h-1.7c-2.9 0.1-5.5 1.1-7.9 3.3 0.7-3.7 2.7-8.3 7.9-8.3h1.7v-6.6c0 0 0.1-0.1 0.2-0.1 0.2 0 0.3 0.1 0.3 0.1 2.4 2.6 6.7 7 8.8 9.1-0.4 0.4-7.2 7.4-8.8 9.1z m-15.5 5.1v-20h13.3v1.6c-7.7 0-10 8.2-10 14.2v0.8c2.9-4.3 6-6.6 10-6.6v5c0 0.9 0.9 1.6 1.9 1.6 0.6 0 1.2-0.2 1.5-0.6 0.9-1 2.1-2.2 3.3-3.4v7.4h-20z' })
        )
    );
};

exports.default = TiExportOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/export-outline.js
// module id = 3826
// module chunks = 0